import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Login from "./components/Login";
import {isValidLogin} from "./service/authService";
import Workers from "./components/Workers";

function App(props) {
    return (<div className="App">
        {isValidLogin('WORKER') ? <Workers/> : <Login/>}

    </div>);
}

export default App;
